// indexedDBHandler.js

import { openDB } from 'idb'

// Функция для открытия базы данных
const dbPromise = openDB('protoCarpBD', 19, {
  upgrade(db) {
    if (db.objectStoreNames.contains('requests')) {
      db.deleteObjectStore('requests')
    }

    if (!db.objectStoreNames.contains('protocols')) {
      const store = db.createObjectStore('protocols', {
        keyPath: 'id',
        autoIncrement: true,
      })
    }

    if (!db.objectStoreNames.contains('tournaments')) {
      const store = db.createObjectStore('tournaments', {
        keyPath: 'id',
        autoIncrement: true,
      })
    }
    if (!db.objectStoreNames.contains('user')) {
      const store = db.createObjectStore('user', {
        keyPath: 'id',
        autoIncrement: true,
      })
    }
    if (!db.objectStoreNames.contains('requests')) {
      const store = db.createObjectStore('requests', {
        keyPath: 'requestKey',
      })
      store.createIndex('by_tournament_id', 'id', { unique: false })
    }
    if (!db.objectStoreNames.contains('archive')) {
      const store = db.createObjectStore('archive', {
        keyPath: 'id',
        autoIncrement: true,
      })
    }
    if (!db.objectStoreNames.contains('teams')) {
      const store = db.createObjectStore('teams', {
        keyPath: 'id',
        autoIncrement: true,
      })
    }
    if (!db.objectStoreNames.contains('communication')) {
      const store = db.createObjectStore('communication', {
        keyPath: 'id',
        autoIncrement: true,
      })
    }

    if (!db.objectStoreNames.contains('stage')) {
      const store = db.createObjectStore('stage', {
        keyPath: 'id',
        autoIncrement: true,
      })
    }

    if (!db.objectStoreNames.contains('sponsors')) {
      const store = db.createObjectStore('sponsors', {
        keyPath: 'id',
        autoIncrement: true,
      })
    }
  },
})
export async function addRequestsData(tableName, data) {
  const db = await dbPromise
  const tx = db.transaction(tableName, 'readwrite')
  const store = tx.objectStore(tableName)

  // Гарантируем наличие уникального requestKey
  const prepareData = (item) => ({
    ...item,
    requestKey:
      item.requestKey ||
      `${item.id}_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`,
  })

  try {
    if (Array.isArray(data)) {
      await Promise.all(data.map((item) => store.put(prepareData(item))))
    } else {
      await store.put(prepareData(data))
    }
    await tx.done
  } catch (error) {
    console.error('DB Error:', error)
    throw error
  }
}
// Функция для добавления данных в таблицу// Функция для добавления данных в таблицу (поддерживает одиночные объекты и массивы)
export async function addData(tableName, data) {
  const db = await dbPromise
  const tx = db.transaction(tableName, 'readwrite')
  const store = tx.objectStore(tableName)

  if (Array.isArray(data)) {
    // Если data — это массив, добавляем каждый элемент по очереди
    for (const item of data) {
      await store.add(item)
    }
  } else {
    // Если data — это одиночный объект, добавляем его
    await store.add(data)
  }

  await tx.done // Ждем завершения транзакции
}
export async function addPushData(tableName, key, data) {
  const db = await dbPromise
  const tx = db.transaction(tableName, 'readwrite')
  const store = tx.objectStore(tableName)

  // Сначала получаем текущие данные по ключу
  let currentData = await store.get(key)

  if (!currentData) {
    // Если данных нет, создаем новый массив
    currentData = { id: key, items: [] }
  }

  // Добавляем новые данные в массив
  if (Array.isArray(data)) {
    currentData.items.push(...data)
  } else {
    currentData.items.push(data)
  }

  // Сохраняем обновленные данные
  await store.put(currentData)

  await tx.done
}
// Функция для получения данных из таблицы
export async function getData(tableName, queryColumn, queryValue) {
  const db = await dbPromise
  const tx = db.transaction(tableName, 'readonly')
  const store = tx.objectStore(tableName)
  const result = []
  let cursor = await store.openCursor()
  while (cursor) {
    if (cursor.value[queryColumn] === queryValue) {
      result.push({
        key: cursor.primaryKey, // Сохраняем ключ
        value: cursor.value, // Сохраняем значение
      })
    }
    cursor = await cursor.continue()
  }
  return result
}

// Функция для обновления данных в таблице
export async function updateData(tableName, id, newData) {
  const db = await dbPromise
  const tx = db.transaction(tableName, 'readwrite')
  const store = tx.objectStore(tableName)
  const existingData = await store.get(id)
  const updatedData = { ...existingData, ...newData }
  await store.put(updatedData)
}

// Функция для удаления данных из таблицы
export async function deleteData(tableName, id) {
  const db = await dbPromise
  await db.delete(tableName, id)
}
// Функция для очистки всех данных из таблицы
export async function clearTable(tableName) {
  const db = await dbPromise
  const tx = db.transaction(tableName, 'readwrite')
  const store = tx.objectStore(tableName)
  await store.clear()
}
export async function countRecords(tableName) {
  const db = await dbPromise
  const tx = db.transaction(tableName, 'readonly')
  const store = tx.objectStore(tableName)
  const count = await store.count()
  return count
}

// Получение всех запросов из IndexedDB
const getRequests = async () => {
  const db = await dbPromise
  return db.getAll('requests')
}
let isProcessing = false
// Обработка запросов
export const processRequests = async () => {
  if (isOnline()) {
    const requests = await getRequests()
    for (const request of requests) {
      const result = await sendRequest(request)
      if (result.success) {
        await deleteRequest(request.requestKey) // Удалить запрос после успешной отправки
      } else {
      }
      return result
    }
  }
}
// Проверка наличия интернета
export const isOnline = () => {
  return navigator.onLine
}
// Удаление запроса из IndexedDB
const deleteRequest = async (id) => {
  const db = await dbPromise
  await db.delete('requests', id)
}
// Отправка запроса на сервер
const sendRequest = async (request) => {
  console.log(request)

  try {
    const results = await getData('user', 'created', true)
    const { key, value } = results[0]

    const response = await fetch(
      'https://admin-protocarp.ru/php/' + request.url,
      {
        method: 'POST',
        headers: request.headers,
        body: JSON.stringify({
          ...request,
          token: value.token,
          phone: value.phone,
        }),
      }
    )
    const data = await response.json()
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}

// export async function upsertDataTournaments(tableName, data) {
//   const db = await dbPromise; // Предполагаем, что dbPromise уже инициализирован
//   const tx = db.transaction(tableName, "readwrite");
//   const store = tx.objectStore(tableName);

//   const processItem = async (item) => {
//     // Используем курсор для поиска записи с соответствующим id_code
//     let found = false;
//     let cursor = await store.openCursor();

//     while (cursor) {
//       if (cursor.value.id_code === item.id_code) {
//         // Обновляем найденную запись
//         const updatedRecord = { ...cursor.value, ...item };
//         await store.put(updatedRecord, cursor.primaryKey);
//         found = true;
//         break; // Прерываем цикл после нахождения соотвествующей записи
//       }
//       cursor = await cursor.continue();
//     }

//     if (!found) {
//       // Добавляем новую запись, если id_code не найден
//       await store.add(item);
//     }
//   };

//   if (Array.isArray(data)) {
//     // Если data — это массив, обрабатываем каждый элемент
//     for (const item of data) {
//       await processItem(item);
//     }
//   } else {
//     // Обработка одной записи
//     await processItem(data);
//   }

//   await tx.done; // Ждем завершения транзакции
// }
export async function upsertDataTournaments(tableName, data) {
  const db = await dbPromise // Предполагаем, что dbPromise уже инициализирован
  const tx = db.transaction(tableName, 'readwrite')
  const store = tx.objectStore(tableName)

  const processItem = async (item) => {
    // Используем курсор для поиска записи с соответствующим id
    let found = false
    let cursor = await store.openCursor()

    while (cursor) {
      if (cursor.value.id === item.id) {
        // Обновляем найденную запись
        const updatedRecord = { ...cursor.value, ...item }
        await store.put(updatedRecord) // Убираем указание первичного ключа
        found = true
        break // Прерываем цикл после нахождения соотвествующей записи
      }
      cursor = await cursor.continue()
    }

    if (!found) {
      // Добавляем новую запись, если id не найден
      await store.add(item)
    }
  }

  if (Array.isArray(data)) {
    // Если data — это массив, обрабатываем каждый элемент
    for (const item of data) {
      await processItem(item)
    }
  } else {
    // Обработка одной записи
    await processItem(data)
  }

  await tx.done // Ждем завершения транзакции
}
export async function getAllData(tableName) {
  const db = await dbPromise
  const tx = db.transaction(tableName, 'readonly')
  const store = tx.objectStore(tableName)
  const allRecords = await store.getAll()
  return allRecords
}
